import { LogParam } from "../types/logParam";

export const logInfo = (logParams: LogParam) => {
    // eslint-disable-next-line no-console
    console.log(`%c ${JSON.stringify(logParams)}`, 'color:green');
  };

  export const logError = (logParams: LogParam) => {
    // eslint-disable-next-line no-console
    console.error(`${JSON.stringify(logParams)}`);
  };